import { z } from "zod"

import { IBAN_REGEX, SWIFT_REGEX } from "../utils/bankingValidation"

export const BankDetailsSchema = z.object({
  swiftCode: z
    .string()
    .trim()
    .optional()
    .refine((val) => !val || val === "" || SWIFT_REGEX.test(val.toUpperCase()), {
      message:
        "SWIFT code must be 8 or 11 characters (4 letters for bank, 2 letters for country, 2 alphanumeric for location, optional 3 alphanumeric for branch)",
    }),
  iban: z
    .string()
    .trim()
    .optional()
    .refine((val) => !val || val === "" || IBAN_REGEX.test(val.toUpperCase().replace(/\s/g, "")), {
      message: "IBAN must be 15-34 alphanumeric characters",
    }),
  routingNumber: z
    .string()
    .trim()
    .optional()
    .refine((val) => !val || val === "" || /^\d{9}$/.test(val), {
      message: "Transit/Routing number must be 9 digits",
    }),
  institutionNumber: z
    .string()
    .trim()
    .optional()
    .refine((val) => !val || val === "" || /^\d{3}$/.test(val), {
      message: "Institution Number must be 3 digits",
    }),
  accountNumber: z
    .string()
    .trim()
    .optional()
    .refine((val) => !val || val === "" || val.length <= 34, {
      message: "Account Number may not exceed 34 characters",
    }),
})

export type BankDetailsFormValues = z.infer<typeof BankDetailsSchema>
